module.exports = __webpack_public_path__ + "img/bg.4edac40f.png";